import React, { useState, useRef, useEffect, useContext } from 'react';
import { Trash2 } from "lucide-react";
import BtnStandard from './BtnStandard';
import moment from 'moment';
import 'moment/locale/fr'; // Pour la langue française
import AppContext from '../Context/AppContext';
import axios from 'axios';
import Loader from './Loader';

moment.locale('fr'); // Active le français

const ConversationTalk = ({ conversationTalk, init,closeConv }) => {

    const { mapUrl } = useContext(AppContext)
    const conversationRef = useRef();
    const [textAdmin, setTextAdmin] = useState("");
    const [load, setLoad] = useState(false)
    const send = async () => {
        if (!load) {
            setLoad(true)
            const response = await axios.post(mapUrl.send_message_admin, { tokenuser: conversationTalk.tokenuser, message: textAdmin })
            if (response?.data) {
                setTextAdmin("")
                await init()
            }
            setLoad(false)
        }
    }
    const handleDelete = async()=>{
        setLoad(true)
        const response = await axios.post(mapUrl.delete_conversations, { tokenuser: conversationTalk.tokenuser })
        if (response?.data) {
            setTextAdmin("")
            await init()
            closeConv(conversationTalk)
        }
        setLoad(false)
    }

    useEffect(() => {
        const container = conversationRef.current;
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    }, [conversationTalk])

    if (!conversationTalk) {
        return <></>
    }
    return (
        <div className='conversation-talk df fdc flex1'>
            <div ref={conversationRef} className='conversation-history oys df fdc flex1'>
                {conversationTalk.messages.map((conv, conv_i) => (
                    <div className={conv.type + ' df mb1'} key={conv_i + "_conv_" + conversationTalk.tokenuser}>
                        <div style={{ display: "inline-flex" }} >
                            <div className={" line-conv"}>
                                <p className='cw fr mb1'>{conv.message}</p>
                                <p className='fl cw fs12'>{moment(conv.created_at).fromNow()}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className='conversation-messenger'>
                <textarea className='fr mb1' onChange={(e) => setTextAdmin(e.currentTarget.value)}>{textAdmin}</textarea>
                <div className='df aic jcsb'>
                    <div>
                        <button onClick={()=>handleDelete()} className='btn cw py1 px2 fr cp bcgrey3 '>
                            {load ? <Loader/>: (
                                <Trash2 size={24} />
                            )}
                        </button>
                    </div>
                    <div>
                        <BtnStandard click={() => send()} label={"Envoyer"} load={load}></BtnStandard>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConversationTalk;